module.exports = __webpack_public_path__ + "img/ico_top_arrow.79b1c702.svg";